// extracted by mini-css-extract-plugin
module.exports = {"block__text":"InnerPage_block__text__2a7DD","wrapper":"InnerPage_wrapper__3pe3q"};